import { z } from 'zod';
import { RideLinkTokenSchema } from './batch_wire.js';

/** A lista é da pessoa logada e nunca leva o código do link. */
export const ReleasedRideSchema = z
  .object({
    linkId: z.uuid(),
    batchName: z.string(),
    clientName: z.string(),
    endsAt: z.iso.datetime(),
  })
  .strict();
export type ReleasedRide = z.infer<typeof ReleasedRideSchema>;

export const ReleasedRidesResponseSchema = z
  .object({ rides: z.array(ReleasedRideSchema) })
  .strict();
export type ReleasedRidesResponse = z.infer<typeof ReleasedRidesResponseSchema>;

/** Navegador → BFF: o código do link, ou o id da lista (a sessão é a credencial). */
export const RideLinkRefSchema = z.union([
  z.object({ token: RideLinkTokenSchema }).strict(),
  z.object({ linkId: z.uuid() }).strict(),
]);
export type RideLinkRef = z.infer<typeof RideLinkRefSchema>;

/** BFF → serviço: o id vem com clientId e userId tirados da sessão, nunca do corpo do navegador. */
export const RideLinkServiceRefSchema = z.union([
  z.object({ token: RideLinkTokenSchema }).strict(),
  z
    .object({
      linkId: z.uuid(),
      clientId: z.string().min(1),
      userId: z.string().min(1),
    })
    .strict(),
]);
export type RideLinkServiceRef = z.infer<typeof RideLinkServiceRefSchema>;
